import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function errText(d) {
  if (!d) return "Login failed. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || String(d);
}

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (admin) return <Navigate to="/admin/discovery" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin/discovery");
    } catch (err) {
      setError(errText(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md border-2 border-ink p-8 shadow-[8px_8px_0_0_#0A0A0C]">
        <Link to="/" className="font-display font-extrabold text-2xl tracking-tighter">AI YAI YAI<span className="text-brorange">!</span></Link>
        <div className="flex items-center gap-2 mt-6 mb-1">
          <Lock size={18} /> <h1 className="font-display font-extrabold text-2xl">Editorial admin</h1>
        </div>
        <p className="text-sm text-ink/60 mb-6">Sign in to manage the case-study database.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eyebrow text-ink/60">Email</label>
            <input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full mt-1 h-11 px-3 border-2 border-ink outline-none focus:shadow-[3px_3px_0_0_#0A0A0C] transition-shadow" />
          </div>
          <div>
            <label className="eyebrow text-ink/60">Password</label>
            <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full mt-1 h-11 px-3 border-2 border-ink outline-none focus:shadow-[3px_3px_0_0_#0A0A0C] transition-shadow" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-brorange font-semibold">{error}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className="group btn-tactile w-full inline-flex items-center justify-center gap-2 bg-ink text-white font-bold h-12 hover:bg-cobalt disabled:opacity-60">
            {busy ? "Signing in…" : <>Sign in <ArrowRight size={18} className="arrow-move" /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
